var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_630_3572)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.503906,
    width: 29.9978,
    height: 29.9995,
    rx: 14.9989,
    fill: "#F5FFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6757 0.450493C9.76336 0.956734 8.86343 1.36923 7.10107 2.55046C2.93888 5.34416 0.539062 9.88158 0.539062 15.0002C0.539062 19.2189 2.0577 22.8564 4.98248 25.7063C7.98225 28.6313 11.3757 30 15.5379 30C19.7001 30 23.0936 28.6313 26.0934 25.7063C28.0995 23.7564 29.3931 21.5064 30.0868 18.7877C31.1555 14.5315 30.3868 9.99408 27.9682 6.48789C26.5621 4.46292 24.2373 2.47546 21.9312 1.31298C19.2876 0.000499725 14.9005 -0.374495 11.6757 0.450493ZM11.1508 7.01288C12.0882 7.95037 11.9569 9.1691 10.8508 9.80659C9.20091 10.7816 7.36355 9.0191 8.30097 7.33163C8.91968 6.2254 10.2133 6.0754 11.1508 7.01288ZM21.8562 11.8316C22.4187 12.1128 22.8311 12.4878 23.1873 13.0878C23.6936 13.969 23.6936 13.9878 23.7498 18.0377L23.806 22.1251H22.2124H20.6V18.7877C20.6 15.9752 20.5438 15.394 20.2813 15.0002C19.8314 14.344 19.6626 14.2503 18.7627 14.2503C18.1065 14.2503 17.844 14.3628 17.394 14.794L16.8503 15.3377V18.7314V22.1251H15.2567H13.6631V16.8752V11.6253H15.2567H16.8503V12.319V13.0128L17.3753 12.5253C17.6565 12.244 18.144 11.8878 18.444 11.7378C19.2501 11.3066 20.8813 11.3628 21.8562 11.8316ZM11.6007 16.8752V22.1251H10.0071H8.41347V16.8752V11.6253H10.0071H11.6007V16.8752Z",
    fill: "#16A02C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_630_3572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9978,
    height: 29.9995,
    fill: "white",
    transform: "translate(0.503906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLi);
export default __webpack_public_path__ + "static/media/li.afafbb338cdb0a26054f2e6ae7a1a506.svg";
export { ForwardRef as ReactComponent };